import { ExternalReportCustomUrlBuilder } from 'app/editor/element/extreport/ExternalReportCustomUrl';
import { ComponentKey } from 'components/common/ComponentIndex';
import { FormTriggerEventMessagesBuilder } from 'app/editor/trigger/TriggerEventMessages';
import { FormEmailTemplateCustomizationBuilder } from 'app/admin/email-template/EmailTemplateCustomization';
import { FormJsonTemplateWithPlaceholdersBuilder } from 'app/editor/user/access-request-profile/JsonTemplateWithPlaceholders';
import { FormCodeEditorBuilder } from 'components/common/code-editor/FormCodeEditorBuilder';
import { CheckBoxListBuilder } from 'components/common/check-box-list/CheckBoxList';
import { MetricResetForAllUsersBuilder } from 'app/editor/element/metric/MetricResetForAllUsers';
import { FormCheckboxBuilder } from 'components/common/form/layout/control/FormCheckbox';
import { FormTextManagerBuilder } from 'components/common/form/layout/control/FormText';
import { DisplayMaskExampleBuilder } from 'components/common/display-mask-example/DisplayMaskExample';
import { FormKpiRuleInfoBuilder } from 'app/editor/kpi-alert-rule/KpiRuleInfo';
import { DataFetchCommandManagerBuilder } from 'components/common/form/DataFetchCommand';
import { RunCustomScriptBuilder } from 'app/admin/custom-script/RunCustomScript';
import { FolderSelectionBuilder } from 'app/editor/element/FolderSelection';
import { FormTemplateFieldBuilder } from 'components/common/form/layout/control/FormTemplateField';
import { PluginGetTokenBuilder } from 'components/common/plugin_get_token/PluginGetToken';
import { DatasetDeleteDataBuilder } from 'components/common/dataset-delete-data/DatasetDeleteData';
import { FormKpiRuleAssignWorkflowLinkBuilder } from 'app/editor/kpi-alert-rule/KpiRuleAssignWorkflowLink';
import { DatasetDataStorageBuilder } from 'components/common/dataset-data-storage/DatasetDataStorage';
import { FormKpiRuleUserMapAccessBuilder } from 'app/editor/kpi-alert-rule/KpiRuleUserMapAccess';
import { VersionIdentifierBuilder } from 'app/editor/page/VersionIdentifier';
import { CertificationControlBuilder } from 'app/editor/element/CertificationControl';
import { SyncNowFormButtonBuilder } from 'app/editor/segment/SyncNowFormButton';
import { EditorTestUrlBuilder } from 'components/common/editor-test-url/EditorTestUrl';
import { FormTriggerCompletedBuilder } from 'app/notification/trigger-completed';
import { ReferenceSelectionBuilder } from 'components/external-reference-selection/ReferenceSelection';
import { MyNotificationInfoBuilder } from 'app/notification/MyNotificationInfo';
import { UncommittedChangesAlertBuilder } from 'app/admin/system-variables/UncommittedChangesAlert';
import { SystemNotificationInfoBuilder } from 'app/notification/SystemNotificationInfo';
import { FormBurstStatusBuilder } from 'components/common/form/layout/control/FormBurstStatus';
import { FormThemeExampleBuilder } from 'app/editor/brand-theme/theme-example/ThemeExample';
import { FormCollectionTriggerBuilder } from 'app/content-workflow/element-editor/CollectionTrigger';
import { FormDescriptionManagerBuilder } from 'components/common/form/layout/control/FormDescription';
import { DatasetBackFillBuilder } from 'components/common/dataset-data-storage/DatasetBackFill';
import { JDBCControlBuilder } from 'components/storage/JDBCControl';
import { FormImagePreviewBuilder } from './layout/control/FormImagePreview';
import { ExternalReportTableauNameBuilder } from 'app/editor/element/extreport/ExternalReportTableauName';
import { FormComponentSlotBuilder } from 'components/common/form/layout/control/FormComponentSlot';
import { FormDatePickerBuilder } from 'components/common/form/layout/control/FormDatePicker';
import { FormThemeUsagePreviewBuilder } from 'app/editor/brand-theme/ThemeUsagePreview';
import { FilterDateDefaultBuilder } from 'app/editor/element/extreport/FilterDateDefault';
import { FormSecureJsonEditorBuilder } from 'app/concierge/form/secure-json-editor/FormSecureJsonEditorBuilder';
import { FormRichTextBuilder } from './layout/control/FormRichText';
import { InternalNameBuilder } from 'app/editor/page/InternalName';
import { SelectMapBuilder } from 'components/common/select-map/SelectMap';
import { FormAppBuilderBuilder } from 'app/app/editor/FormAppBuilder';
import { RestoreDefaultsFormButtonBuilder } from 'app/editor/brand-theme/RestoreDefaults';
import { FormChartColumnsListBuilder } from 'components/common/form/layout/app-builder/FormChartColumnsList';
import { FormConciergeSetupDescriptionBuilder } from 'components/common/form/layout/app-builder/FormConciergeSetupDescription';
import { FormKPISectionBuilder } from 'components/common/form/layout/app-builder/FormKPISectionList';
import { FormSubmenuListBuilder } from 'components/common/form/layout/app-builder/FormSubmenuList';
import { FormTextDescriptionBuilder } from 'components/common/form/layout/app-builder/FormTextDescription';
import { FormStaticImageBuilder } from './layout/static/FormStaticImage';
import { FormResourceTypeLabelBuilder } from 'app/concierge/form/resource-type-label/FormResourceTypeLabelBuilder';
import { FormMetadataSettingsBuilder } from 'app/editor/brand-theme/metadata-settings/MetadataSettings';
import { ChooseIconBuilder } from 'components/common/choose-icon/ChooseIcon';
import { ChooseIconSvgBuilder } from 'components/common/choose-icon/ChooseIconSvg';
import { FormUrlFieldBuilder } from './layout/control/FormUrlField';
import { FormTokenlessUsersBuilder } from 'app/notification/tokenless-users/TokenlessUsers';
import { FormComponentBuilder } from 'components/common/form/layout';
import { FormSelectBuilder } from 'components/common/form/layout/control/FormSelect';
import { EditorExternalFiltersGridBuilder } from 'app/editor/external-filters/EditorExternalFiltersGrid';
import { FormTransferListBuilder } from 'components/common/transfer-list/TransferList';
import { ElementImageControlBuilder } from 'components/element-image';
import { UserSelectionControlBuilder } from 'components/common/user-selection';
import { FormStateButtonBuilder } from './layout/control/FormStateButton';
import { ReferenceExternalFiltersManagerBuilder } from 'components/external-reference/editor/ReferenceExternalFiltersManager';
import { FilterUsageRefreshButtonBuilder } from 'app/editor/external-filters/FilterUsageRefreshButton';
import { FormTimeFieldBuilder } from './layout/control/FormTimeField';
import { FormCompareInputBuilder } from './layout/control/FormCompareInput';
import { FormTimeSelectBuilder } from './layout/control/FormTimeSelect';
import { FormDateSelectBuilder } from './layout/control/FormDateSelect';
import { ColorPickerBuilder } from 'components/common/color-picker/ColorPicker';
import { PublicImagePreviewBuilder } from 'components/element-image/public-image-preview/PublicImagePreview';
import { FormUniquenessTextBuilder } from './layout/control/FormUniquenessText';
import { FormSliderBuilder } from './layout/control/FormSlider';
import { ImageListHandlerBuilder } from 'components/common/image-list-handler/ImageListHandler';
import { CSVUploaderBuilder } from 'app/editor/dataset/CSVUploader';
import { PageVariablesBuilder } from 'app/editor/page/variables/PageVariables';
import { FormButtonBuilder } from './layout/control/FormButton';

const FormComponentsBuilderMap: {
    [key in ComponentKey]?: typeof FormComponentBuilder;
} = {
    CheckBoxList: CheckBoxListBuilder,
    ChooseIcon: ChooseIconBuilder,
    ChooseIconSvg: ChooseIconSvgBuilder,
    CodeEditor: FormCodeEditorBuilder,
    SecureJsonEditor: FormSecureJsonEditorBuilder,
    ResourceTypeLabel: FormResourceTypeLabelBuilder,
    ColorPicker: ColorPickerBuilder,
    DataFetchCommand: DataFetchCommandManagerBuilder,
    EditorExternalFiltersGrid: EditorExternalFiltersGridBuilder,
    ElementImageControl: ElementImageControlBuilder,
    FilterUsageRefreshButton: FilterUsageRefreshButtonBuilder,
    FormCheckbox: FormCheckboxBuilder,
    FormCompareInput: FormCompareInputBuilder,
    FormDatePicker: FormDatePickerBuilder,
    FormDateSelect: FormDateSelectBuilder,
    FormSelect: FormSelectBuilder,
    FormStateButton: FormStateButtonBuilder,
    FormStaticImage: FormStaticImageBuilder,
    FormText: FormTextManagerBuilder,
    FormRichText: FormRichTextBuilder,
    FormComponentSlot: FormComponentSlotBuilder,
    FormDescription: FormDescriptionManagerBuilder,
    FormTextarea: FormTextManagerBuilder,
    FormTimeField: FormTimeFieldBuilder,
    FormTimeSelect: FormTimeSelectBuilder,
    FormTransferList: FormTransferListBuilder,
    FormEmailTemplateCustomization: FormEmailTemplateCustomizationBuilder,
    FormJsonTemplateWithPlaceholders: FormJsonTemplateWithPlaceholdersBuilder,
    FormTemplateField: FormTemplateFieldBuilder,
    FormUrlField: FormUrlFieldBuilder,
    JDBCControl: JDBCControlBuilder,
    PublicImagePreview: PublicImagePreviewBuilder,
    ReferenceExternalFiltersManager: ReferenceExternalFiltersManagerBuilder,
    ReferenceSelection: ReferenceSelectionBuilder,
    SelectMap: SelectMapBuilder,
    TokenlessUsers: FormTokenlessUsersBuilder,
    FormTriggerEventMessages: FormTriggerEventMessagesBuilder,
    MetricResetForAllUsers: MetricResetForAllUsersBuilder,
    DisplayMaskExample: DisplayMaskExampleBuilder,
    KpiRuleInfo: FormKpiRuleInfoBuilder,
    KpiRuleAssignWorkflowLink: FormKpiRuleAssignWorkflowLinkBuilder,
    KpiRuleUserMapAccess: FormKpiRuleUserMapAccessBuilder,
    RunCustomScript: RunCustomScriptBuilder,
    FolderSelection: FolderSelectionBuilder,
    PluginGetToken: PluginGetTokenBuilder,
    EditorTestUrl: EditorTestUrlBuilder,
    DatasetDeleteData: DatasetDeleteDataBuilder,
    DatasetDataStorage: DatasetDataStorageBuilder,
    DatasetBackFill: DatasetBackFillBuilder,
    VersionIdentifier: VersionIdentifierBuilder,
    InternalName: InternalNameBuilder,
    CertificationControl: CertificationControlBuilder,
    UserSelection: UserSelectionControlBuilder,
    SegmentSyncButton: SyncNowFormButtonBuilder,
    RestoreDefaultsFormButton: RestoreDefaultsFormButtonBuilder,
    TriggerCompleted: FormTriggerCompletedBuilder,
    MyNotificationInfo: MyNotificationInfoBuilder,
    UncommittedChangesAlert: UncommittedChangesAlertBuilder,
    SystemNotificationInfo: SystemNotificationInfoBuilder,
    FormBurstStatus: FormBurstStatusBuilder,
    ThemeExample: FormThemeExampleBuilder,
    MetadataSettings: FormMetadataSettingsBuilder,
    ThemeUsagePreview: FormThemeUsagePreviewBuilder,
    CollectionTrigger: FormCollectionTriggerBuilder,
    FormImagePreview: FormImagePreviewBuilder,
    ExternalReportTableauName: ExternalReportTableauNameBuilder,
    FilterDateDefault: FilterDateDefaultBuilder,
    FormAppBuilder: FormAppBuilderBuilder,
    FormChartColumnsList: FormChartColumnsListBuilder,
    FormConciergeSetupDescription: FormConciergeSetupDescriptionBuilder,
    FormKPISectionList: FormKPISectionBuilder,
    FormSubmenuList: FormSubmenuListBuilder,
    FormTextDescription: FormTextDescriptionBuilder,
    FormUniquenessText: FormUniquenessTextBuilder,
    ExternalReportCustomUrl: ExternalReportCustomUrlBuilder,
    FormSlider: FormSliderBuilder,
    ImageListHandler: ImageListHandlerBuilder,
    CSVUploader: CSVUploaderBuilder,
    PageVariables: PageVariablesBuilder,
    FormButton: FormButtonBuilder,
    // Components has only basic props
    GlobalVariables: FormComponentBuilder,
    VariablesGrid: FormComponentBuilder,
    UserAlert: FormComponentBuilder,
    UserActionLinks: FormComponentBuilder,
    EmbedCodePopup: FormComponentBuilder,
};

export function getFormComponentBuilderByKey(key: ComponentKey): typeof FormComponentBuilder | undefined {
    return FormComponentsBuilderMap[key];
}
